import FirmwareVersionEditor from './firmware-version-editor';

export default FirmwareVersionEditor;